export default {
  path: '/2019MetroSmallTheater',
  name: '2019MetroSmallTheater',
  component: () => import('./Home.vue'),
  redirect: '/2019MetroSmallTheater/OperasList',
  meta: {
    title: '上游·都市小剧场',
  },
  children: [
    {
      path: 'OperasList',
      component: () => import('./OperasList.vue'),
      name: 'OperasList',
      meta: {
        title: '上游·都市小剧场',
      },
    },
    {
      path: 'NewsCenter',
      component: () => import('./NewsCenter.vue'),
      name: 'NewsCenter',
      meta: {
        title: '上游·都市小剧场',
      },
    },
    {
      path: 'TicketsSnatch',
      component: () => import('./TicketsSnatch.vue'),
      name: 'TicketsSnatch',
      meta: {
        title: '上游·都市小剧场',
      },
    },
    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: 'DetailPage',
      meta: {
        title: '上游·都市小剧场',
      },
    },
  ],
};
